var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.mode === "create"
      ? _c(
          "div",
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { md: "6" } },
                  [
                    _c(
                      "b-form-group",
                      {
                        class: {
                          "error-input": _vm.$v.data_division.name.$error
                        }
                      },
                      [
                        _c("label", [_vm._v(" Name ")]),
                        _vm._v(" "),
                        _c("j-input", {
                          attrs: { "max-length": 255, placeholder: "Name" },
                          model: {
                            value: _vm.$v.data_division.name.$model,
                            callback: function($$v) {
                              _vm.$set(_vm.$v.data_division.name, "$model", $$v)
                            },
                            expression: "$v.data_division.name.$model"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { md: "6" } },
                  [
                    _c(
                      "b-form-group",
                      {
                        class: {
                          "error-input": _vm.$v.data_division.code.$error
                        }
                      },
                      [
                        _c("label", [_vm._v(" Code ")]),
                        _vm._v(" "),
                        _c("j-input", {
                          attrs: { "max-length": 255, placeholder: "Code" },
                          model: {
                            value: _vm.$v.data_division.code.$model,
                            callback: function($$v) {
                              _vm.$set(_vm.$v.data_division.code, "$model", $$v)
                            },
                            expression: "$v.data_division.code.$model"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { md: "6" } },
                  [
                    _c(
                      "b-form-group",
                      {
                        class: {
                          "error-input":
                            _vm.$v.data_division.head_of_division.$error
                        }
                      },
                      [
                        _c("label", [_vm._v(" Head Of Division ")]),
                        _vm._v(" "),
                        _c("j-single-select", {
                          attrs: {
                            "is-async": true,
                            "load-options": _vm.loadOptionsPosition,
                            "default-options": false,
                            placeholder: "Ex: CTO",
                            "value-format": "object",
                            label: "name",
                            "search-prompt-text":
                              "Type minimum 3 characters to search..."
                          },
                          model: {
                            value: _vm.$v.data_division.head_of_division.$model,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.$v.data_division.head_of_division,
                                "$model",
                                $$v
                              )
                            },
                            expression:
                              "$v.data_division.head_of_division.$model"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { md: "6" } },
                  [
                    _c(
                      "b-form-group",
                      {
                        class: {
                          "error-input": _vm.$v.data_division.description.$error
                        }
                      },
                      [
                        _c("label", [_vm._v(" Description ")]),
                        _vm._v(" "),
                        _c("j-textarea", {
                          attrs: {
                            "max-length": 300,
                            placeholder: "Description"
                          },
                          model: {
                            value: _vm.$v.data_division.description.$model,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.$v.data_division.description,
                                "$model",
                                $$v
                              )
                            },
                            expression: "$v.data_division.description.$model"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _c(
          "div",
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { md: "6" } },
                  [
                    _c(
                      "b-form-group",
                      {
                        class: { "error-input": _vm.$v.data_division.id.$error }
                      },
                      [
                        _c("label", [_vm._v(" Division ID ")]),
                        _vm._v(" "),
                        _c("j-input", {
                          attrs: {
                            "max-length": 50,
                            disabled: true,
                            placeholder: "ID"
                          },
                          model: {
                            value: _vm.$v.data_division.id.$model,
                            callback: function($$v) {
                              _vm.$set(_vm.$v.data_division.id, "$model", $$v)
                            },
                            expression: "$v.data_division.id.$model"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { md: "6" } },
                  [
                    _c(
                      "b-form-group",
                      {
                        class: {
                          "error-input": _vm.$v.data_division.code.$error
                        }
                      },
                      [
                        _c("label", [_vm._v(" Division Code ")]),
                        _vm._v(" "),
                        _c("j-input", {
                          attrs: { "max-length": 255, placeholder: "Code" },
                          model: {
                            value: _vm.$v.data_division.code.$model,
                            callback: function($$v) {
                              _vm.$set(_vm.$v.data_division.code, "$model", $$v)
                            },
                            expression: "$v.data_division.code.$model"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { md: "6" } },
                  [
                    _c(
                      "b-form-group",
                      {
                        class: {
                          "error-input": _vm.$v.data_division.name.$error
                        }
                      },
                      [
                        _c("label", [_vm._v(" Division Name ")]),
                        _vm._v(" "),
                        _c("j-input", {
                          attrs: { "max-length": 255, placeholder: "Name" },
                          model: {
                            value: _vm.$v.data_division.name.$model,
                            callback: function($$v) {
                              _vm.$set(_vm.$v.data_division.name, "$model", $$v)
                            },
                            expression: "$v.data_division.name.$model"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      {
                        class: {
                          "error-input":
                            _vm.$v.data_division.head_of_division.$error
                        }
                      },
                      [
                        _c("label", [_vm._v(" Head Of Division ")]),
                        _vm._v(" "),
                        _c("j-single-select", {
                          attrs: {
                            "is-async": true,
                            "load-options": _vm.loadOptionsPosition,
                            "default-options": false,
                            placeholder: "Ex: CTO",
                            "value-format": "object",
                            label: "name",
                            "search-prompt-text":
                              "Type minimum 3 characters to search..."
                          },
                          model: {
                            value: _vm.$v.data_division.head_of_division.$model,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.$v.data_division.head_of_division,
                                "$model",
                                $$v
                              )
                            },
                            expression:
                              "$v.data_division.head_of_division.$model"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { md: "6" } },
                  [
                    _c(
                      "b-form-group",
                      {
                        class: {
                          "error-input": _vm.$v.data_division.description.$error
                        }
                      },
                      [
                        _c("label", [_vm._v(" Description ")]),
                        _vm._v(" "),
                        _c("j-textarea", {
                          attrs: {
                            "max-length": 300,
                            rows: 5,
                            placeholder: "Description"
                          },
                          model: {
                            value: _vm.$v.data_division.description.$model,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.$v.data_division.description,
                                "$model",
                                $$v
                              )
                            },
                            expression: "$v.data_division.description.$model"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15fe88d3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15fe88d3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/division/jDivisionForm.vue
// module id = null
// module chunks = 